import React, { useContext, useEffect } from "react";

import AppContext from "../../context/AppContext";
import { SIDER_TABS } from "../../utils/Constants";
import { AppStrings } from "../../utils/constants/AppStrings";
import { usePageTitle } from "../CommonComponents/Layout/PageTitleContext";
import BetsReport from "./BetsReport/BetsReport";

/**
 * Monitoring entry point: same Latest Bets List as legacy Sportsbook, under its own route.
 */
const MonitoringLatestBetsList: React.FC = () => {
  usePageTitle(AppStrings.LATEST_BETS_LIST);
  const { setActiveSidebarTab } = useContext(AppContext);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.SPORTSBOOK, "LATEST_BETS_LIST");
  }, [setActiveSidebarTab]);

  return (
    <>
      <BetsReport />
    </>
  );
};

export default MonitoringLatestBetsList;
